export default __webpack_public_path__ + "/dist/images/3600942.png";